import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { logOut } from '../../helpers/configRoutes/backend_helper';

export default function Menu() {
    const navigate = useNavigate();
    const user = useSelector((state) => state.Login.user);
    const location = useLocation();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isDesktopMenuVisible, setIsDesktopMenuVisible] = useState(true);

    const menuItems = [
        { name: 'Inicio', link: '/inicio', icon: 'bar_chart_4_bars', activeRoutes: ['/inicio'] },
        { name: 'Usuarios', link: '/usuarios', icon: 'groups_3' },
        { name: 'Vendedores', link: '/vendedores', icon: 'real_estate_agent' },
        { name: 'Departamentos', link: '/departamentos', icon: 'category' },
        { name: 'Áreas', link: '/areas', icon: 'category_search' },
        { name: 'Productos', link: '/productos', icon: 'barcode' },
        { name: 'Ventas', link: '/ventas', icon: 'attach_money', activeRoutes: ['/ventas', '/ventas/nueva', '/venta/', '/ventas/editar'] },
        { name: 'Clientes', link: '/clients-follow', icon: 'barcode' },
        
    ];

    const menuItemsMob = [
        { name: 'Inicio', link: '/inicio', icon: 'bar_chart_4_bars', activeRoutes: ['/inicio'] },
        { name: 'Vendedores', link: '/vendedores', icon: 'real_estate_agent' },
        { name: 'Ventas', link: '/ventas', icon: 'attach_money', activeRoutes: ['/ventas', '/ventas/nueva', '/venta/', '/ventas/editar'] },
        { name: 'Clientes', link: '/clients-follow', icon: 'barcode' },
    ];

    const handleLogout = async () => {
        await logOut();
        localStorage.clear();
        navigate('/login');
    };

    const isRouteActive = (item) => {
        const current = location.pathname;
        const routes = item.activeRoutes || [item.link];
        return routes.some(route => current === route || current.startsWith(route));
    };

    return (
        <>
            {/* Botón toggle (desktop) */}
            <button
                onClick={() => setIsDesktopMenuVisible(!isDesktopMenuVisible)}
                className="hidden md:flex fixed bottom-6 left-6 z-50 w-11 h-11 items-center justify-center rounded-full bg-fr-primary text-fr-light shadow-lg hover:bg-fr-primary-hover transition-colors"
                title="Mostrar/Ocultar menú"
            >
                <span className="material-symbols-outlined text-[20px]">
                    {isDesktopMenuVisible ? 'left_panel_close' : 'left_panel_open'}
                </span>
            </button>

            {/* Sidebar Desktop */}
            {isDesktopMenuVisible && (
                <aside className="hidden md:flex flex-col h-screen w-64 bg-fr-light border-r border-fr-muted shrink-0">
                    {/* Brand */}
                    <div className="h-[68px] flex items-center px-5 border-b border-fr-muted">
                        <div className="w-10 h-10 rounded-lg bg-fr-primary flex items-center justify-center shrink-0">
                            <img
                                src={user?.imageProfile || "./images/usrAnonimo.png"}
                                alt="Profile"
                                className="w-9 h-9 rounded-full object-cover ring-2 ring-white dark:ring-white/10 shadow-sm"
                            />
                        </div>
                        <div className="ml-3">
                            <p className="text-fr-dark font-semibold text-sm tracking-tight leading-tight">{user.information?.name || 'User'}</p>
                            <p className="text-[10px] text-fr-dark/50 tracking-[0.18em] uppercase leading-tight mt-0.5">{user.information?.job_title || 'Job Title'}</p>
                        </div>
                    </div>

                    {/* Etiqueta de sección */}
                    <div className="px-5 pt-5 pb-2">
                        <p className="text-[10px] font-semibold tracking-[0.2em] text-fr-dark/40 uppercase">
                            Menú principal
                        </p>
                    </div>

                    {/* Items */}
                    <nav className="flex-1 overflow-y-auto px-3 py-1 space-y-0.5">
                        {menuItems.map((item, index) => {
                            const isActive = isRouteActive(item);
                            return (
                                <Link
                                    to={item.link}
                                    key={index}
                                    className={`group relative flex items-center h-10 px-3 rounded-lg transition-colors duration-150
                                        ${isActive
                                            ? 'bg-fr-primary/10 text-fr-primary'
                                            : 'text-fr-dark/70 hover:bg-fr-secondary hover:text-fr-dark'
                                        }`}
                                >
                                    {/* Indicador lateral del item activo */}
                                    {isActive && (
                                        <span className="absolute left-0 top-1/2 -translate-y-1/2 w-[3px] h-5 bg-fr-primary rounded-r-full"></span>
                                    )}

                                    <span className={`material-symbols-outlined text-[20px] mr-3 ${isActive ? 'text-fr-primary' : 'text-fr-dark/50 group-hover:text-fr-dark'}`}>
                                        {item.icon}
                                    </span>

                                    <span className={`text-sm tracking-tight ${isActive ? 'font-semibold' : 'font-medium'}`}>
                                        {item.name}
                                    </span>
                                </Link>
                            );
                        })}
                    </nav>

                    {/* Footer: usuario + logout */}
                    <div className="border-t border-fr-muted p-3 space-y-1">
                        {user && (
                            <div className="flex items-center gap-3 h-12 px-2">
                                <div className="relative shrink-0">
                                    <img
                                        src={user.imageProfile || "/images/usrAnonimo.png"}
                                        alt="Profile"
                                        className="w-9 h-9 rounded-full object-cover"
                                    />
                                    <span className="absolute -bottom-0.5 -right-0.5 w-2.5 h-2.5 rounded-full bg-fr-success ring-2 ring-fr-light"></span>
                                </div>
                                <div className="min-w-0 flex-1">
                                    <p className="text-sm font-semibold text-fr-dark truncate tracking-tight leading-tight">
                                        {user.first_name}
                                    </p>
                                    <p className="text-[11px] text-fr-dark/50 truncate leading-tight">
                                        {user.role}
                                    </p>
                                </div>
                            </div>
                        )}


                    </div>
                </aside>
            )}

            {/* Drawer móvil */}
            <div className={`fixed inset-0 z-40 md:hidden ${isMenuOpen ? 'visible' : 'invisible'}`}>
                <div
                    className={`absolute inset-0 bg-fr-dark/40 backdrop-blur-sm transition-opacity duration-300 ${isMenuOpen ? 'opacity-100' : 'opacity-0'}`}
                    onClick={() => setIsMenuOpen(false)}
                ></div>
                <div className={`relative w-72 h-full bg-fr-light flex flex-col transition-transform duration-300 ease-out shadow-2xl ${isMenuOpen ? 'translate-x-0' : '-translate-x-full'}`}>
                    {/* Brand */}
                    <div className="h-[68px] flex items-center justify-between px-5 border-b border-fr-muted">
                        <div className="flex items-center gap-3">
                            <div className="w-10 h-10 rounded-lg bg-fr-primary flex items-center justify-center">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" className="w-[18px] h-[18px]">
                                    <path d="M12 2 L2 7 L12 12 L22 7 Z" />
                                    <path d="M2 17 L12 22 L22 17" />
                                    <path d="M2 12 L12 17 L22 12" />
                                </svg>
                            </div>
                            <div>
                                <p className="text-fr-dark font-semibold text-sm tracking-tight leading-tight">FactuRadar</p>
                                <p className="text-[10px] text-fr-dark/50 tracking-[0.18em] uppercase leading-tight mt-0.5">Workspace</p>
                            </div>
                        </div>
                        <button
                            onClick={() => setIsMenuOpen(false)}
                            className="w-9 h-9 rounded-lg flex items-center justify-center text-fr-dark/60 hover:bg-fr-secondary"
                        >
                            <span className="material-symbols-outlined text-[20px]">close</span>
                        </button>
                    </div>

                    <div className="px-5 pt-5 pb-2">
                        <p className="text-[10px] font-semibold tracking-[0.2em] text-fr-dark/40 uppercase">
                            Menú principal
                        </p>
                    </div>

                    <nav className="flex-1 overflow-y-auto px-3 py-1 space-y-0.5">
                        {menuItems.map((item, index) => {
                            const isActive = isRouteActive(item);
                            return (
                                <Link
                                    to={item.link}
                                    key={index}
                                    onClick={() => setIsMenuOpen(false)}
                                    className={`group relative flex items-center h-10 px-3 rounded-lg transition-colors
                                        ${isActive
                                            ? 'bg-fr-primary/10 text-fr-primary'
                                            : 'text-fr-dark/70 hover:bg-fr-secondary hover:text-fr-dark'
                                        }`}
                                >
                                    {isActive && (
                                        <span className="absolute left-0 top-1/2 -translate-y-1/2 w-[3px] h-5 bg-fr-primary rounded-r-full"></span>
                                    )}
                                    <span className={`material-symbols-outlined text-[20px] mr-3 ${isActive ? 'text-fr-primary' : 'text-fr-dark/50'}`}>
                                        {item.icon}
                                    </span>
                                    <span className={`text-sm tracking-tight ${isActive ? 'font-semibold' : 'font-medium'}`}>
                                        {item.name}
                                    </span>
                                </Link>
                            );
                        })}
                    </nav>

                    <div className="border-t border-fr-muted p-3 space-y-1">
                        {user && (
                            <div className="flex items-center gap-3 h-12 px-2">
                                <div className="relative">
                                    <img
                                        src={user.imageProfile || "/images/usrAnonimo.png"}
                                        alt="Profile"
                                        className="w-9 h-9 rounded-full object-cover"
                                    />
                                    <span className="absolute -bottom-0.5 -right-0.5 w-2.5 h-2.5 rounded-full bg-fr-success ring-2 ring-fr-light"></span>
                                </div>
                                <div className="min-w-0">
                                    <p className="text-sm font-semibold text-fr-dark truncate tracking-tight leading-tight">{user.first_name}</p>
                                    <p className="text-[11px] text-fr-dark/50 truncate leading-tight">{user.role}</p>
                                </div>
                            </div>
                        )}
                        <button
                            onClick={() => { setIsMenuOpen(false); handleLogout(); }}
                            className="group w-full flex items-center h-10 px-3 rounded-lg text-fr-dark/70 hover:bg-fr-danger/10 hover:text-fr-danger transition-colors"
                        >
                            <span className="material-symbols-outlined text-[20px] mr-3">logout</span>
                            <span className="text-sm font-medium">Cerrar sesión</span>
                        </button>
                    </div>
                </div>
            </div>

            {/* Bottom nav móvil */}
            <div className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-fr-light border-t border-fr-muted pb-[env(safe-area-inset-bottom)]">
                <div className="flex justify-around items-center py-2 px-1">
                    <button
                        onClick={() => setIsMenuOpen(true)}
                        className="flex flex-col items-center justify-center flex-1 py-1"
                    >
                        <span className="material-symbols-outlined text-[22px] text-fr-dark/60">menu</span>
                        <span className="text-[10px] font-medium tracking-tight text-fr-dark/60 mt-0.5">Menú</span>
                    </button>

                    {menuItemsMob.slice(0, 4).map((item, index) => {
                        const isActive = isRouteActive(item);
                        return (
                            <Link
                                key={index}
                                to={item.link}
                                className="flex flex-col items-center justify-center flex-1 py-1 group"
                            >
                                <span className={`material-symbols-outlined text-[22px] ${isActive ? 'text-fr-primary' : 'text-fr-dark/60'}`}>
                                    {item.icon}
                                </span>
                                <span className={`text-[10px] font-medium tracking-tight mt-0.5 ${isActive ? 'text-fr-primary font-semibold' : 'text-fr-dark/60'}`}>
                                    {item.name}
                                </span>
                            </Link>
                        );
                    })}
                </div>
            </div>
        </>
    );
}
